// Canonical personalisation variables for the intake form builder.
// Extend by adding one entry — no mechanism change.
// `resolve(ctx)` returns the value string, or null/'' when unavailable (→ fallback).
export const VARIABLES = [
  { token: "{{Activiteitnaam}}", label: "Activiteitnaam", resolve: (ctx) => ctx?.activityName },
  { token: "{{Locatienaam}}", label: "Locatienaam", resolve: (ctx) => ctx?.locationName },
  { token: "{{Contactpersoon}}", label: "Contactpersoon", resolve: (ctx) => ctx?.generalContactName },
  // Unlike the others, this Value is not static context — it is the answer of the
  // activity's own contact field (prefilled from the offerte). See ADR-0019.
  { token: "{{Contactpersoon activiteit}}", label: "Contactpersoon activiteit", resolve: (ctx) => ctx?.activityContactName },
];

export const normalizeName = (name) =>
  String(name).trim().replace(/\s+/g, " ").toLowerCase();

const BY_KEY = VARIABLES.reduce((map, variable) => {
  map[normalizeName(variable.label)] = variable;
  return map;
}, {});

export const findVariable = (rawName) => BY_KEY[normalizeName(rawName)] || null;
